//libraries
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Navbar, Container, Nav, Image, Dropdown, NavDropdown, Button, Tab, Tabs } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Redirect, Route, Switch, useHistory, useRouteMatch, useParams } from 'react-router-dom';

//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';
import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';

//assets
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faRedditSquare, faGithub } from '@fortawesome/free-brands-svg-icons';
import icon_verified from '../../assets/img/ui_icons/icono-verificado@2x.png'
import logo_cloud from '../../assets/img/AVAP_Cloud.svg'
import logo_collab from '../../assets/img/AVAP_Cloud.svg'
import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'

//dummy data
import icon_cloud from '../../assets/img/logos/icono_Cloud.svg'
import icon_dev from '../../assets/img/logos/icono_DSs.svg'
import icon_api from '../../assets/img/logos/icon_APIControVersion.svg'
import icon_publisher from '../../assets/img/logos/icono_publisher.svg'
import icon_linter from '../../assets/img/logos/icon_avap.svg'
import icon_descarga from '../../assets/img/ui_icons/icono-descarga.svg'

import plh_1 from '../../assets/img/placeholder/placeholder01@2x.png'
import plh_2 from '../../assets/img/placeholder/placeholder02@2x.png'



//Dummy Data
const icons = {
    "icon_dev": icon_dev,
    "icon_api": icon_api,
    "icon_publisher": icon_publisher,
    "icon_linter": icon_linter,
};
//dummy Data Json
import appsData from './appsData.json'
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';


const MarketplaceStoreAllapps = () => {
    
    const [apps, setApps] = useState([]);

    const getApps = async () => {
        try {
          const result = (await ObexRequestHandler.get('/api_product_list')).data;
          setApps(result);


        } catch (error) {
          console.error('ERROR FETCHING APPS ', error);
        }
      }
    useEffect(() => {
        getApps();

        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // favicon
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    // const apps = appsData.apps || [];

    return (
        <>
            <NavbarMarket />

            <div id='allApps' className="w-100 bg-antiflash">
                <div className="w-100 bg-footer topbar">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <a href="/marketplaceStore">
                                    All Categories
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className='txt-20 txt-bold' style={{fontSize:'1.5rem', marginTop:'15px'}}>
                                All
                            </p>
                        </div>
                    </div>
                </div>
                <section className='container'>
                    <div className="row">
                        {apps.map((item) => (
                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                               <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                    <div className='icon'>
                                        <Image src={atob(item.icon).toString()} />
                                    </div>

                                    <div className="infoWrapper">
                                        <div className='title'>{item.name}</div>
                                        <div className="developerName">{item.devName}  </div>
                                        <div className='infoDw'>
                                            <div className="version">
                                                Version {item.version}
                                            </div>
                                            <div className="downloads">
                                                <Image src={icon_descarga} /> {item.installations}
                                            </div>
                                        </div>
                                    </div>

                                    <hr className='mb-0 mt-3' />
                                    <div className="bottom">

                                        <div className="stars">
                                            <div className="iconWrapper">
                                                <Image src={icon_cloud} />
                                            </div>
                                            {Array.from({ length: 5 }, (v, i) => (
                                                <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStar}
                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                    size="1x"
                                                />
                                            ))}
                                        </div>
                                        <div className="type">
                                            {item.type}
                                        </div>
                                    </div>

                                </a>
                            </Col>
                        ))}
                    </div>

                    <div className="row pt-4">
                        {apps.map((item) => (
                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                               <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                    <div className='icon'>
                                        <Image src={atob(item.icon).toString()} />
                                    </div>

                                    <div className="infoWrapper">
                                        <div className='title'>{item.name}</div>
                                        <div className="developerName">{item.devName}  </div>
                                        <div className='infoDw'>
                                            <div className="version">
                                                Version {item.version}
                                            </div>
                                            <div className="downloads">
                                                <Image src={icon_descarga} /> {item.installations}
                                            </div>
                                        </div>
                                    </div>

                                    <hr className='mb-0 mt-3' />
                                    <div className="bottom">

                                        <div className="stars">
                                            <div className="iconWrapper">
                                                <Image src={icon_cloud} />
                                            </div>
                                            {Array.from({ length: 5 }, (v, i) => (
                                                <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStar}
                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                    size="1x"
                                                />
                                            ))}
                                        </div>
                                        <div className="type">
                                            {item.type}
                                        </div>
                                    </div>

                                </a>
                            </Col>
                        ))}
                    </div>

                    <div className="row pt-4">
                        {apps.map((item) => (
                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                    <div className='icon'>
                                        <Image src={atob(item.icon).toString()} />
                                    </div>

                                    <div className="infoWrapper">
                                        <div className='title'>{item.name}</div>
                                        <div className="developerName">{item.devName}  </div>
                                        <div className='infoDw'>
                                            <div className="version">
                                                Version {item.version}
                                            </div>
                                            <div className="downloads">
                                                <Image src={icon_descarga} /> {item.installations}
                                            </div>
                                        </div>
                                    </div>

                                    <hr className='mb-0 mt-3' />
                                    <div className="bottom">

                                        <div className="stars">
                                            <div className="iconWrapper">
                                                <Image src={icon_cloud} />
                                            </div>
                                            {Array.from({ length: 5 }, (v, i) => (
                                                <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStar}
                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                    size="1x"
                                                />
                                            ))}
                                        </div>
                                        <div className="type">
                                            {item.type}
                                        </div>
                                    </div>

                                </a>
                            </Col>
                        ))}
                    </div>

                    <div className="row pt-4 pb-5">
                        {apps.map((item) => (
                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                    <div className='icon'>
                                        <Image src={atob(item.icon).toString()} />
                                    </div>

                                    <div className="infoWrapper">
                                        <div className='title'>{item.name}</div>
                                        <div className="developerName">{item.devName}  </div>
                                        <div className='infoDw'>
                                            <div className="version">
                                                Version {item.version}
                                            </div>
                                            <div className="downloads">
                                                <Image src={icon_descarga} /> {item.installations}
                                            </div>
                                        </div>
                                    </div>

                                    <hr className='mb-0 mt-3' />
                                    <div className="bottom">

                                        <div className="stars">
                                            <div className="iconWrapper">
                                                <Image src={icon_cloud} />
                                            </div>
                                            {Array.from({ length: 5 }, (v, i) => (
                                                <FontAwesomeIcon
                                                    key={i}
                                                    icon={faStar}
                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                    size="1x"
                                                />
                                            ))}
                                        </div>
                                        <div className="type">
                                            {item.type}
                                        </div>
                                    </div>

                                </a>
                            </Col>
                        ))}
                    </div>

                </section>




                <FooterMenuAccess green={true} />

            </div>

        </>
    )
}

export default MarketplaceStoreAllapps;